import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private httpRes: HttpRequestService) { }

  GetNews()
  {
      return this.httpRes.GetRequest(`News/GetNews`);
  }

  GetSpecialNews()
  {
      return this.httpRes.GetRequest(`News/GetSpecialNews`);
  }

  GetNewsDisplayedAtMainPage()
  {
      return this.httpRes.GetRequest(`News/GetNewsDisplayedAtMainPage`);
  }

  GetNewsById(id)
  {
      return this.httpRes.GetRequest(`News/GetNewsById/${id}`);
  }

  AddNews(news: any){
    return this.httpRes.postRequest(`News/AddNews`,news);
  }

  DeleteNews(id){
    return this.httpRes.GetRequest(`News/DeleteNews/${id}`);
  }

  UpdateNews(news : any){
    return this.httpRes.postRequest(`News/UpdateNews`,news);
  }

  UpdateNewsImage(image: any , NewsId:any)
  {
    const formData: FormData = new FormData();
    formData.append('record',image , image.name);

      return this.httpRes.postFile(`News/UpdateNewsImage/${NewsId}`, formData);
  }
}
